(() => {
  const initGuide = (guide) => {
    if (guide.dataset.ready === 'true') return;
    guide.dataset.ready = 'true';

    const nav = guide.querySelector('[data-education-nav]');
    const desktop = guide.querySelector('[data-education-nav-desktop]');
    const links = Array.from(guide.querySelectorAll('[data-education-target]'));
    const select = guide.querySelector('[data-education-select]');
    const targets = links
      .map((link) => document.getElementById(link.dataset.educationTarget))
      .filter(Boolean);
    const end = document.querySelector('[data-education-guide-end]');
    let desktopHeight = 0;

    const clearTarget = (card, targetMain) => {
      card._educationTargetMain = null;
      if (!targetMain) return;
      const secondary = targetMain.querySelector(':scope > .education-relocation__secondary');
      if (secondary?.querySelector('[data-education-relocatable]')) return;
      if (secondary) secondary.remove();
      targetMain.classList.remove('education-main--split');
      const primary = targetMain.querySelector(':scope > .education-relocation__primary');
      if (primary) {
        while (primary.firstChild) targetMain.insertBefore(primary.firstChild, primary);
        primary.remove();
      }
    };

    const restoreCard = (card) => {
      const previousTarget = card._educationTargetMain;
      if (card.parentNode !== card._educationOrigin) {
        card._educationOrigin.insertBefore(card, card._educationNext);
      }
      if (card._educationOriginSection) card._educationOriginSection.hidden = false;
      clearTarget(card, previousTarget);
    };

    const findNeighbourTarget = (card, direction) => {
      let sibling = card._educationOriginWrapper?.[direction === 'previous' ? 'previousElementSibling' : 'nextElementSibling'];
      while (sibling) {
        const main = sibling.querySelector('.education-main');
        if (main) return main;
        sibling = sibling[direction === 'previous' ? 'previousElementSibling' : 'nextElementSibling'];
      }
      return null;
    };

    const findTargetMain = (card) => {
      if (card.dataset.educationPlacement === 'previous' || card.dataset.educationPlacement === 'next') {
        return findNeighbourTarget(card, card.dataset.educationPlacement);
      }
      if (card.dataset.educationPlacement === 'target' && card.dataset.educationTarget) {
        return document.getElementById(card.dataset.educationTarget)?.querySelector('.education-main') || null;
      }
      return null;
    };

    const prepareTarget = (targetMain) => {
      let primary = targetMain.querySelector(':scope > .education-relocation__primary');
      if (!primary) {
        primary = document.createElement('div');
        primary.className = 'education-relocation__primary';
        targetMain.prepend(primary);
      }
      Array.from(targetMain.childNodes).forEach((node) => {
        const isSecondary = node.nodeType === Node.ELEMENT_NODE && node.matches('.education-relocation__secondary');
        if (node !== primary && !isSecondary) primary.appendChild(node);
      });
      let secondary = targetMain.querySelector(':scope > .education-relocation__secondary');
      if (!secondary) {
        secondary = document.createElement('div');
        secondary.className = 'education-relocation__secondary';
        targetMain.appendChild(secondary);
      }
      targetMain.classList.add('education-main--split');
      return secondary;
    };

    const relocateCards = () => {
      document.querySelectorAll('[data-education-relocatable]').forEach((card) => {
        if (card._educationOrigin && !card._educationOrigin.isConnected) {
          const previousTarget = card._educationTargetMain;
          card.remove();
          clearTarget(card, previousTarget);
          return;
        }
        if (!card._educationOrigin) {
          card._educationOrigin = card.parentNode;
          card._educationNext = card.nextSibling;
          card._educationOriginSection = card.closest('.education-end-card');
          card._educationOriginWrapper = card.closest('.shopify-section');
        }

        if (!window.matchMedia('(min-width: 1200px)').matches || card.dataset.educationPlacement === 'standalone') {
          restoreCard(card);
          return;
        }

        const targetMain = findTargetMain(card);
        if (!targetMain || targetMain === card._educationOrigin) {
          restoreCard(card);
          return;
        }

        const previousTarget = card._educationTargetMain;
        if (previousTarget && previousTarget !== targetMain) {
          card._educationOrigin.insertBefore(card, card._educationNext);
          clearTarget(card, previousTarget);
        }

        const secondary = prepareTarget(targetMain);
        if (card.parentNode !== secondary) secondary.appendChild(card);
        card._educationTargetMain = targetMain;
        if (card._educationOriginSection) card._educationOriginSection.hidden = true;
      });
    };

    const goTo = (id) => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    links.forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      goTo(link.dataset.educationTarget);
    }));

    if (select) select.addEventListener('change', () => goTo(select.value));

    let scheduled = false;
    const update = () => {
      scheduled = false;
      relocateCards();
      const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
      const marker = window.scrollY + offset + 48;
      let active = targets[0];
      targets.forEach((target) => {
        if (target.offsetTop <= marker) active = target;
      });

      if (active) {
        links.forEach((link) => link.classList.toggle('is-active', link.dataset.educationTarget === active.id));
        if (select) select.value = active.id;
      }

      if (desktop && nav && end && window.matchMedia('(min-width: 1200px)').matches) {
        if (!desktopHeight) desktopHeight = desktop.offsetHeight;
        const start = guide.getBoundingClientRect().top + window.scrollY + 49 - offset - 24;
        const stop = end.getBoundingClientRect().bottom + window.scrollY - desktopHeight - offset - 24;
        desktop.classList.toggle('is-fixed', window.scrollY >= start && window.scrollY < stop);
        desktop.classList.toggle('is-ended', window.scrollY >= stop);
      } else if (desktop) {
        desktop.classList.remove('is-fixed', 'is-ended');
      }
    };

    const requestUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    relocateCards();
    update();
  };

  const initAll = () => document.querySelectorAll('[data-education-page]').forEach(initGuide);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', () => {
    initAll();
    window.dispatchEvent(new Event('resize'));
  });
})();
